var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-btn-icon-outlined-rounded', _vm._b({
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScroll,
      expression: "onScroll"
    }],
    staticClass: "btn-top-primary",
    attrs: {
      "fixed": "",
      "x-large": "",
      "color": "grey lighten-3"
    },
    on: {
      "click": function ($event) {
        return _vm.$vuetify.goTo(_vm.target, _vm.options);
      }
    }
  }, 'u-btn-icon-outlined-rounded', _vm.$attrs, false), [_c('span', {
    staticClass: "font-size-14 grey--text text--darken-4"
  }, [_vm._v("TOP")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }